import { Controller } from '@hotwired/stimulus';

export class AriaController extends Controller {
  toggleExpanded() {
    this.element.setAttribute('aria-expanded', this.element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }
}
